import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
	name: 'dynamicProperty'
})
export class DynamicPropertyPipe implements PipeTransform {
	transform(value: any, key: string): unknown {
		return value ? value[key] : null;
	}
}
